import styled from 'styled-components';

type EmbedSizeProps = {
  height?: string | number;
  width?: string | number;
};

export type EmbedVideoProps = {
  url: string;
} & EmbedSizeProps;

export const EmbedVideo = ({ url, ...rest }: EmbedVideoProps) => {
  let id = getYoutubeId(url);
  if (id) return <YouTubeEmbed id={id} {...rest} />;

  id = getVimeoId(url);
  if (id) return <VimeoEmbed id={id} {...rest} />;

  return null;
};

const youtubeUrlRegex =
  /(?:youtube\.com\/(?:embed|shorts|live)\/|youtube-nocookie\.com\/embed\/)([\w-]+)|youtube\.com\/watch\?v=([\w-]+)|youtu\.be\/([\w-]+)/;
const vimeoUrlRegex = /(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-zA-Z0-9]+))?/;

const getVimeoId = (url: string) => {
  const match = vimeoUrlRegex.exec(url);
  if (!match) return;

  const id = match[1];
  // Hash from path (vimeo.com/id/hash for unlisted videos)
  const pathHash = match[2];
  if (pathHash) return `${id}?h=${pathHash}`;

  // Hash from query param (player.vimeo.com/video/id?h=hash)
  try {
    const h = new URL(url).searchParams.get('h');
    if (h) return `${id}?h=${h}`;
  } catch {
    // invalid URL, ignore
  }

  return id;
};

const getYoutubeId = (url: string) => {
  const match = youtubeUrlRegex.exec(url);
  if (!match) return;

  return match[1] || match[2] || match[3];
};

type EmbedImplProps = {
  id: string;
} & EmbedSizeProps;

const VimeoEmbed = ({ id, width = '100%', height = 240 }: EmbedImplProps) => {
  return (
    <FrameContainer>
      <iframe
        width={width}
        height={height}
        src={`https://player.vimeo.com/video/${id}`}
        allowFullScreen
        title="Vimeo video"
      />
    </FrameContainer>
  );
};

const YouTubeEmbed = ({ id, height = 241, width = 432 }: EmbedImplProps) => {
  return (
    <FrameContainer>
      <iframe
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${id}`}
        allowFullScreen
        title="YouTube video"
      />
    </FrameContainer>
  );
};
const FrameContainer = styled.div({
  overflow: 'hidden',
  iframe: {
    border: 'none',
  },
});
